/**
 * Map role codes to full display names
 */
export const getRoleDisplayName = (role) => {
  if (!role) return 'Unknown';
  
  const roleMap = {
    'agent': 'Writing Agent',
    'fta': 'Field Training Agent',
    'fsl': 'Field Sales Leader',
    'satellite': 'Satellite'
  };
  
  return roleMap[role.toLowerCase()] || role.toUpperCase();
};

/**
 * Get role color for badges
 */
export const getRoleColor = (role) => {
  if (!role) return 'bg-gray-100 text-gray-800';
  
  const colorMap = {
    'satellite': 'bg-purple-100 text-purple-800 dark:bg-purple-900 dark:text-purple-200',
    'fsl': 'bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-200',
    'fta': 'bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200',
    'agent': 'bg-yellow-100 text-yellow-800 dark:bg-yellow-900 dark:text-yellow-200'
  };
  
  return colorMap[role.toLowerCase()] || 'bg-gray-100 text-gray-800 dark:bg-gray-900 dark:text-gray-200';
};
